/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import swal from 'sweetalert';
import GoBackButton from '../../../components/GoBackButton';
import { userContext } from '../../../contextProvider/Authentication';
import { getDDMMYYYY } from '../../../Functions/dates';
// import { decrypt } from '../../../Functions/authentication';
import axiosInstance from '../../../services/AxiosInstance';
import PageTitle from '../../Layout/PageTitle';

var bnr = require('../../../images/banner/bnr1.jpg');

function Jobdetail() {
	const { jobId } = useParams();
	const history = useHistory();

	const { authenticated, user, siteConfig } = useContext(userContext);

	const [job, setJob] = useState();
	const [hasProfile, setHasProfile] = useState();
	const [applied, setApplied] = useState();

	useEffect(() => {
		axiosInstance(`post-jobs/${jobId}/`, { method: "GET" })
			.then(res => setJob(res?.data));
		axiosInstance(`can-applyjob/?user=${user?.id}&job=${jobId}`, { method: "GET" })
			.then(res => { setApplied(res?.data?.results?.[0]) });
		axiosInstance('user/has_profile', { method: "GET" })
			.then(res => { setHasProfile(res?.data); })
	}, []);

	const applyJob = () => {
		if (authenticated) {
			let lurl = applied?.status === 'Saved' ? `can-applyjob/${applied?.id}/` : `can-applyjob/`;
			let lmethod = applied?.status === 'Saved' ? "PUT" : "POST";
			let ldata = applied?.status === 'Saved' ? { "status": "a", "job": jobId, "user": user?.id } : { "job": jobId, "user": user?.id };
			axiosInstance(lurl, { method: lmethod, data: ldata })
				.then(res => {
					if (res.status === 201 || res.status === 200) {
						swal("", "Job has been applied Successfully", "success", { button: "Ok!", });
						history.push("/candidate/jobs-applied-job")
					}
				}).catch(err => {
					console.log('err: ', err.response);
					swal("", Object.values(err.response.data).join(','), "error", { button: "Ok!", })
				})
		} else history.push('/login')
	}

	const appreoveJob = (status) => {
		if (status === 'a') {
			swal(`Enter the amount to be paid by employer for ${job.vacancies} candidates:`, {
				content: "input",
			})
				.then((value) => {
					if (value) {
						axiosInstance(`post-jobs/${jobId}/`, { method: "PATCH", data: { "job_status": status, "amount": value } })
							.then(res => {
								if (res.status === 200) {
									swal("", "Job status updated successfully", "success", { button: "Ok!", });
									history.push(authenticated ? '/joc/all-jobs' : '/login')
								}
							}).catch(err => swal("", Object.values(err.response.data).join(', '), "error", { button: "Ok!", }))
					}

				});
		} else {
			axiosInstance(`post-jobs/${jobId}/`, { method: "PATCH", data: { "job_status": status } })
				.then(res => {
					if (res.status === 200) {
						swal("", "Job status updated successfully", "success", { button: "Ok!", });
						history.push(authenticated ? '/joc/all-jobs' : '/login')
					}
				}).catch(err => swal("", Object.values(err.response.data).join(', '), "error", { button: "Ok!", }))
		}
	}

	const handlePayment = () => {
		swal(`Enter the amount to pay for ${job.vacancies} candidates:`, {
			content: {
				element: "input",
				attributes: {
					placeholder: "Enter the amount",
					type: "number",
				},
			},
		})
			.then((value) => {
				if (value) {
					axiosInstance('payments/payment/', {
						method: "POST", data: {
							"amount": value,
							"job": jobId
						}
					}).then(res => {
						if (res.status === 200) {
							axiosInstance(`post-jobs/${jobId}/`, { method: "PATCH", data: { "job_status": "pd", "amount": value } })
								.then(res => {
									if (res.status === 200) {
										swal("", "Job status updated successfully", "success", { button: "Ok!", });
										history.push(authenticated ? '/joc/all-jobs' : '/login')
									}
								}).catch(err => swal("", Object.values(err.response.data).join(', '), "error", { button: "Ok!", }))
						}
					}).catch(err => swal("", Object.values(err.response.data).join(', '), "error", { button: "Ok!", }))
				}
			});
	}

	return (
		<>
			<div className="page-content bg-white mb-5">
				<div className="dez-bnr-inr overlay-black-middle" style={{ backgroundImage: "url(" + bnr + ")" }}>
					<PageTitle activeName="Job Detail" motherName="Home" />
				</div>
				<div className="content-block">
					<div className="section-full content-inner-1">
						<GoBackButton />
						<div className="container">
							<div className="row">
								<div className="col-lg-4">
									<div className="sticky-top">
										<div className="row">
											<div className="col-lg-12 col-md-6">
												<div className="m-b30">
													<img src={require("../../../images/blog/grid/pic1.jpg")} alt="" />
												</div>
											</div>
											<div className="col-lg-12 col-md-6">
												<div className="widget bg-white p-lr20 p-t20  widget_getintuch radius-sm">
													<h4 className="text-black font-weight-700 p-t10 m-b15">Job Details</h4>
													<ul>
														<li><i className="ti-location-pin"></i><strong className="font-weight-700 text-black">Address</strong><span className="text-black-light">{job?.address && job?.address + ','} {job?.city?.name}, {job?.state?.name}, {job?.country?.name} </span></li>
														<li><i className="ti-mone"> {job?.country?.symbol}</i><strong className="font-weight-700 text-black">Salary</strong> {job?.country?.symbol}{job?.min_salary} - {job?.max_salary} per {job?.salary_per?.name}</li>
														<li><i className="ti-shield"></i><strong className="font-weight-700 text-black">Experience</strong>{job?.min_experience} - {job?.max_experience} Year Experience</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-lg-8">
									<div className="job-info-box">
										<h3 className="m-t0 m-b10 font-weight-700 title-head">
											<Link to={"#"} className="text-secondry m-r30">{job?.title?.name}</Link>
										</h3>
										<ul className="job-info">
											<li><strong>Education: </strong> {job?.preferred_qualification.map(res => <>{res?.name}, </>)} </li>
											<li><strong>Deadline: </strong>{getDDMMYYYY(job?.end_time?.split('T')?.[0])} </li>
											<li><i className="ti-location-pin text-black m-r5"></i> {job?.country?.name} </li>
										</ul>
										<div className="dez-divider divider-2px bg-gray-dark mb-4 mt-0"></div>
										<h5 className="font-weight-600">Job Description</h5>
										<div className="dez-divider divider-2px bg-gray-dark mb-4 mt-0"></div>
										<p>{job?.description}</p>
										<h5 className="font-weight-600">Required Skills</h5>
										<div className="dez-divider divider-2px bg-gray-dark mb-4 mt-0"></div>
										<ul className="list-num-count no-round">
											{job?.skills?.map(skill => skill?.name).join(', ')}
										</ul>
										{
											user?.role === 1 ?
												<>
													{
														job?.job_status === "Pending" &&
														<>
															{
																siteConfig.online_payment &&
																<Link to="#"
																	className="site-button"
																	onClick={() => appreoveJob("a")}
																	disabled={job?.job_status === "Accepted" ? true : false}
																>
																	<span title="If you approve the employer has to pay through Online">Approve</span>
																</Link>
															}
															<Link to="#"
																className="site-button btn-success ml-2"
																onClick={() => handlePayment()}
															>
																<span title="Get the amount and Approve">Pay & Approve</span>
															</Link>
															<Link to={authenticated ? '/joc/all-jobs' : `/login`}
																className="site-button btn-danger ml-2"
																onClick={() => appreoveJob("r")}
															>
																<span title="Reject this job">Reject</span>
															</Link>
														</>
													}
													{
														job?.job_status === "Accepted" &&
														<><Link to={authenticated ? '/joc/all-jobs' : `/login`}
															className="site-button btn-danger"
															onClick={() => appreoveJob("r")}
														>
															Reject
														</Link> Waiting for employer's Payment </>
													}
													{job?.job_status === "Paid" && "Amount has been paid."}
													{job?.job_status === "Rejected" &&
														<Link to="#"
															className="site-button mr-2"
															onClick={() => appreoveJob("a")}
															disabled={job?.job_status === "Accepted" ? true : false}
														>
															Approve
														</Link>
													}
													{/* {
														!(job?.job_status === "Accepted") &&
														<Link to="#"
															className="site-button mr-2"
															onClick={() => appreoveJob("a")}
															disabled={job?.job_status === "Accepted" ? true : false}
														>
															Approve This Job
														</Link>
													}
													<Link to={authenticated ? '/all-jobs' : `/login`}
														className="site-button btn-danger"
														onClick={() => appreoveJob("r")}
													>
														Reject This Job
													</Link> */}
												</>
												:
												user?.role === 4 ?
													<>
														{
															hasProfile?.has_profile ?
																<>
																	{
																		((typeof (applied) === 'undefined') || applied?.status === "Saved") &&
																		<button
																			onClick={() => applyJob()}
																			className="site-button"
																			style={{ backgroundColor: "#1d46f5", cursor: "pointer" }}
																		>
																			Apply This Job
																		</button>

																	}
																</>
																:
																<h5 className='text-danger'>Please update your profile to apply for this job</h5>
														}
														{
															applied?.status === "Applied" &&
															<span className="ml-4 font-weight-bold text-danger">
																You have already applied for this post
															</span>
														}
													</>
													: user?.role === 4 || user?.role === 2 ? null :
														<Link to="/login">
															<button
																className="site-button"
															>
																Apply This Job
															</button>
														</Link>
										}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
export default Jobdetail;